export default __webpack_public_path__ + "static/media/4-Cloudxier-CSR-Report-Pertamina.e06cbb13.JPEG";